import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'portals-timezone-icon',
  templateUrl: './timezone-icon.component.html',
  styleUrls: ['./timezone-icon.component.scss']
})
export class TimezoneIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
